import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ComponentBase } from '../../base-classes/componet-base';

@Component({
  selector: 'app-root',
  templateUrl: './web-app.component.html',
  styleUrls: ['./web-app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WebAppComponent extends ComponentBase implements OnInit {

  ngOnInit() {
    localStorage.setItem("ACCOUNT_TYPE", "STUDENT");
  }
}
